import { collectWarpMeshes } from './warpMeshes';
import type { WorldInit } from './initializeWorld';
import type { ControlRuntimeEnv } from './controlRuntime';

export function createControlRuntimeEnv(init: WorldInit): ControlRuntimeEnv {
  const canvas = init.renderer.domElement;
  return {
    env: init.env,
    painterPose: init.painterPose,
    painterView: init.data.painterView,
    camera: init.camera,
    materials: init.materials,
    warpMeshes: collectWarpMeshes(init.world.root),
    capturePainterView: () => {
      init.pipeline.painterHandoff?.capture(init.scene, init.camera);
    },
    get canvasWidth() {
      return canvas.clientWidth;
    },
    get canvasHeight() {
      return canvas.clientHeight;
    },
  };
}
